import React from "react";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

const RefundPolicy = () => (
  <PolicyLayout eyebrow="Policies" title="Refunds & Returns" updated="August 2026">
    <p className="text-lg">Because every Venus piece is made to order for you, our refund policy is written with that in mind — please read it carefully before purchase.</p>

    <PolicySection title="Damaged in transit">
      <p>If your piece arrives damaged, please <strong>email us within 48 hours of delivery</strong> at <a href="mailto:venus3dcreations@gmail.com" className="text-[var(--copper)] vc-link-underline">venus3dcreations@gmail.com</a> with clear photographs of the damage and the outer packaging.</p>
      <p>We will arrange a replacement at no extra cost, or issue a full refund to the original payment method — whichever you prefer. Please keep the original packaging until the case is resolved.</p>
    </PolicySection>

    <PolicySection title="Defective or incorrect product">
      <p>If you receive a piece that is defective (technical fault) or different from what you ordered, write to us within <strong>7 days of delivery</strong> with photos. We will replace it or refund it in full, and cover the return shipping.</p>
    </PolicySection>

    <PolicySection title="Order cancellation / change of mind">
      <p>You can cancel or modify your order within <strong>12 hours</strong> of placing it — just email us with your order number and we'll refund you in full to the original payment method.</p>
      <p>After 12 hours, production has begun and orders can no longer be cancelled or refunded for change of mind. Please review your order carefully before confirming payment.</p>
    </PolicySection>

    <PolicySection title="Custom commissions">
      <p>Custom-designed pieces are non-refundable once production begins. We invest significant hours in the design and printing process, and each piece is unique to your brief.</p>
      <p>If you have concerns during the design consultation (before production), we’re happy to iterate until you’re happy — that stage is fully collaborative.</p>
    </PolicySection>

    <PolicySection title="How refunds are processed">
      <p>Approved refunds are issued to the <strong>original payment method</strong> — the same card, UPI or netbanking account you paid from. Refunds typically appear in your account within <strong>5–7 business days</strong> after we initiate them.</p>
    </PolicySection>

    <PolicySection title="Return shipping">
      <p>For damaged or defective pieces, <strong>we cover return shipping</strong> — we’ll arrange a reverse pickup with our courier partner. Shipping charges on the original order are non-refundable.</p>
    </PolicySection>

    <PolicySection title="Return address">
      <p>All approved returns should be shipped to our studio only after we’ve confirmed the return in writing:</p>
      <p className="pl-4 border-l-2 border-[var(--copper)] italic">Venus 3D Creations<br/>201 Samvaad Residency, Mahadevnagar Society<br/>Stadium Road, Ahmedabad, Gujarat 380009<br/>India</p>
      <p>Please do not send items without prior confirmation — unsolicited returns cannot be processed.</p>
    </PolicySection>

    <PolicySection title="How to start a return">
      <ol className="list-decimal list-inside space-y-1 pl-2">
        <li>Email <a href="mailto:venus3dcreations@gmail.com" className="text-[var(--copper)] vc-link-underline">venus3dcreations@gmail.com</a> with your order number and a brief description of the issue.</li>
        <li>Attach photos where relevant (damage, defect, wrong item).</li>
        <li>We will respond within 48 hours with next steps — either a return pickup, a replacement, or a refund.</li>
      </ol>
    </PolicySection>

    <PolicySection title="Questions">
      <p>We’re a small studio and every piece matters to us. If something isn’t right, please write to us — we will make it right. <a href="mailto:venus3dcreations@gmail.com" className="text-[var(--copper)] vc-link-underline">venus3dcreations@gmail.com</a> or <a href="tel:+918849440828" className="text-[var(--copper)] vc-link-underline">+91 88494 40828</a>.</p>
    </PolicySection>
  </PolicyLayout>
);

export default RefundPolicy;
